var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GlslShader"},[_c('canvas',{ref:"canvas",staticClass:"canvas",class:{ show: _vm.ready },attrs:{"id":"canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }